/**
 * Procedural catalog thumbnails (SVG data URLs) — no binary assets shipped.
 */

const CATEGORY_COLORS = {
  living: "#60a5fa",
  bedroom: "#a78bfa",
  dining: "#f59e0b",
  office: "#34d399",
  storage: "#f472b6",
  decor: "#f87171",
  kitchen: "#fb923c",
  bathroom: "#22d3ee",
  lighting: "#facc15",
  electronics: "#818cf8",
  kids: "#fb7185",
  garage: "#9ca3af",
  building: "#a8a29e",
};

const CATEGORY_LABELS = {
  living: "Living",
  bedroom: "Bedroom",
  dining: "Dining",
  office: "Office",
  storage: "Storage",
  decor: "Decor",
  kitchen: "Kitchen",
  bathroom: "Bathroom",
  lighting: "Lighting",
  electronics: "Electronics",
  kids: "Kids",
  garage: "Garage",
  building: "Building",
};

function svgUri(svg) {
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

const ICON_WRAP = (body) =>
  `<svg class="catalog-cat-tile__svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" aria-hidden="true">${body}</svg>`;

/** Cute per-category glyphs — rounded, filled-soft, readable at ~22px. */
const CATEGORY_ICONS = {
  living: ICON_WRAP(`
    <rect x="3.5" y="14" width="25" height="10" rx="3.2" fill="currentColor" opacity=".18"/>
    <rect x="5.2" y="9.5" width="10" height="8" rx="2.6" fill="currentColor" opacity=".32"/>
    <rect x="16.8" y="9.5" width="10" height="8" rx="2.6" fill="currentColor" opacity=".32"/>
    <path d="M5 24.2v2.2M27 24.2v2.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
    <path d="M4 16.2h24" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" opacity=".85"/>
  `),
  bedroom: ICON_WRAP(`
    <rect x="4" y="15" width="24" height="9.5" rx="2.8" fill="currentColor" opacity=".18"/>
    <path d="M4 16.2V11.4c0-1.5 1.2-2.7 2.7-2.7H14v7.5" fill="currentColor" opacity=".3"/>
    <path d="M4 16.2V11.4c0-1.5 1.2-2.7 2.7-2.7H14" stroke="currentColor" stroke-width="1.55" stroke-linecap="round"/>
    <path d="M4 16.2h24M6.2 24.6v1.8M25.8 24.6v1.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    <circle cx="10.2" cy="12.4" r="1.35" fill="currentColor" opacity=".55"/>
  `),
  dining: ICON_WRAP(`
    <ellipse cx="16" cy="18.2" rx="10.5" ry="3.2" fill="currentColor" opacity=".16"/>
    <path d="M8 18.2c0-5.4 3.6-8.4 8-8.4s8 3 8 8.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    <path d="M16 9.8v10.2M11.2 24.4h9.6" stroke="currentColor" stroke-width="1.65" stroke-linecap="round"/>
    <circle cx="16" cy="17.4" r="2.1" fill="currentColor" opacity=".28"/>
  `),
  kitchen: ICON_WRAP(`
    <path d="M8.2 14.2h15.6c.9 0 1.6.8 1.5 1.7l-1.1 9.1c-.1.9-.9 1.6-1.8 1.6H9.6c-.9 0-1.7-.7-1.8-1.6l-1.1-9.1c-.1-.9.6-1.7 1.5-1.7Z" fill="currentColor" opacity=".2" stroke="currentColor" stroke-width="1.5"/>
    <path d="M12 14.2V11.6c0-2.2 1.8-3.4 4-3.4s4 1.2 4 3.4v2.6" stroke="currentColor" stroke-width="1.55" stroke-linecap="round"/>
    <path d="M11.4 7.2c.4-1.1 1.2-1.8 2.2-1.8M20.6 7.2c-.4-1.1-1.2-1.8-2.2-1.8" stroke="currentColor" stroke-width="1.45" stroke-linecap="round"/>
    <circle cx="16" cy="20.4" r="1.5" fill="currentColor" opacity=".45"/>
  `),
  bathroom: ICON_WRAP(`
    <path d="M5.5 16.8c0-.8.7-1.5 1.5-1.5h18c.8 0 1.5.7 1.5 1.5v3.4c0 4-4.3 6.6-10.5 6.6S5.5 24.2 5.5 20.2v-3.4Z" fill="currentColor" opacity=".2" stroke="currentColor" stroke-width="1.55"/>
    <path d="M7.2 15.3V10.8c0-2 1.5-3.5 3.4-3.5" stroke="currentColor" stroke-width="1.55" stroke-linecap="round"/>
    <circle cx="21.6" cy="12.2" r="1.55" fill="currentColor" opacity=".4"/>
    <circle cx="24.4" cy="10.2" r="1.05" fill="currentColor" opacity=".28"/>
  `),
  storage: ICON_WRAP(`
    <path d="M6.4 12.2 16 7.6l9.6 4.6v12.2c0 .9-.7 1.6-1.6 1.6H8c-.9 0-1.6-.7-1.6-1.6V12.2Z" fill="currentColor" opacity=".18" stroke="currentColor" stroke-width="1.55" stroke-linejoin="round"/>
    <path d="M6.4 12.2 16 16.6l9.6-4.4M16 16.6v9.4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  `),
  decor: ICON_WRAP(`
    <path d="M16 5.8c2.8 3.2 7.6 6.8 7.6 11.2A7.6 7.6 0 1 1 8.4 17c0-4.4 4.8-8 7.6-11.2Z" fill="currentColor" opacity=".2" stroke="currentColor" stroke-width="1.55"/>
    <path d="M16 14.2v12M13.2 19.6h5.6" stroke="currentColor" stroke-width="1.55" stroke-linecap="round"/>
    <circle cx="19.6" cy="11.4" r="1.2" fill="currentColor" opacity=".45"/>
  `),
  office: ICON_WRAP(`
    <rect x="5.2" y="8.2" width="21.6" height="13.4" rx="2.4" fill="currentColor" opacity=".18" stroke="currentColor" stroke-width="1.55"/>
    <path d="M5.2 18.4h21.6M12.4 26.2h7.2M16 21.6v4.6" stroke="currentColor" stroke-width="1.55" stroke-linecap="round"/>
    <rect x="8.2" y="10.6" width="7.2" height="5" rx="1" fill="currentColor" opacity=".32"/>
    <circle cx="21.2" cy="13.2" r="1.2" fill="currentColor" opacity=".4"/>
  `),
  lighting: ICON_WRAP(`
    <path d="M16 5.4v2.4M9.4 8.2l1.7 1.7M22.6 8.2l-1.7 1.7" stroke="currentColor" stroke-width="1.55" stroke-linecap="round"/>
    <path d="M11.2 13.4a4.8 4.8 0 1 1 9.6 0c0 2.1-1.3 3.4-2.2 4.4-.6.7-.8 1.3-.8 2v.4h-3.6v-.4c0-.7-.2-1.3-.8-2-.9-1-2.2-2.3-2.2-4.4Z" fill="currentColor" opacity=".22" stroke="currentColor" stroke-width="1.55"/>
    <path d="M13.4 22.6h5.2M14.2 25.2h3.6" stroke="currentColor" stroke-width="1.55" stroke-linecap="round"/>
  `),
  electronics: ICON_WRAP(`
    <rect x="4.6" y="7.4" width="22.8" height="15.2" rx="2.6" fill="currentColor" opacity=".18" stroke="currentColor" stroke-width="1.55"/>
    <rect x="7.2" y="9.8" width="17.6" height="10.2" rx="1.4" fill="currentColor" opacity=".28"/>
    <path d="M13 25.4h6M16 22.6v2.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    <circle cx="16" cy="15" r="1.15" fill="currentColor" opacity=".55"/>
  `),
  kids: ICON_WRAP(`
    <circle cx="16" cy="13.4" r="6.2" fill="currentColor" opacity=".2" stroke="currentColor" stroke-width="1.55"/>
    <circle cx="13.6" cy="12.6" r="1.05" fill="currentColor"/>
    <circle cx="18.4" cy="12.6" r="1.05" fill="currentColor"/>
    <path d="M13.8 16.2c.7.9 1.5 1.3 2.2 1.3s1.5-.4 2.2-1.3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M10.4 9.2c-1.4-1.6-3.4-1.5-4.2-.4M21.6 9.2c1.4-1.6 3.4-1.5 4.2-.4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M11.6 20.2c-1.6 1.4-2 3.6-1 5.1M20.4 20.2c1.6 1.4 2 3.6 1 5.1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  `),
  garage: ICON_WRAP(`
    <path d="M5.4 16.4 16 8.2l10.6 8.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.2 15.8V24.8h17.6V15.8" fill="currentColor" opacity=".18" stroke="currentColor" stroke-width="1.55"/>
    <path d="M11.4 24.8v-5.4h9.2v5.4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <circle cx="16" cy="12.2" r="1.15" fill="currentColor" opacity=".45"/>
  `),
  building: ICON_WRAP(`
    <path d="M6.4 26.2V12.6L16 6.6l9.6 6v13.6" fill="currentColor" opacity=".18" stroke="currentColor" stroke-width="1.55" stroke-linejoin="round"/>
    <path d="M13.2 26.2v-6.2h5.6v6.2" stroke="currentColor" stroke-width="1.5"/>
    <rect x="9.2" y="14.2" width="2.6" height="2.6" rx=".6" fill="currentColor" opacity=".45"/>
    <rect x="20.2" y="14.2" width="2.6" height="2.6" rx=".6" fill="currentColor" opacity=".45"/>
    <rect x="14.7" y="14.2" width="2.6" height="2.6" rx=".6" fill="currentColor" opacity=".45"/>
  `),
};

const FALLBACK_ICON = ICON_WRAP(`
  <rect x="7" y="7" width="18" height="18" rx="5" fill="currentColor" opacity=".18" stroke="currentColor" stroke-width="1.55"/>
  <path d="M12 16h8M16 12v8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
`);

/** Inline SVG icon for a catalog category tile. */
export function categoryIcon(category) {
  const key = String(category ?? "").toLowerCase();
  return CATEGORY_ICONS[key] ?? FALLBACK_ICON;
}

/** Category tile icon (square grid entry). */
export function categoryThumb(category) {
  const color = CATEGORY_COLORS[category] ?? "#94a3b8";
  const label = CATEGORY_LABELS[category] ?? category;
  const glyph = categoryIcon(category).replace("currentColor", color);
  return svgUri(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
      <rect width="120" height="120" rx="16" fill="${color}22"/>
      <g transform="translate(28,18) scale(2)">${glyph.replace(/^<svg[^>]*>/, "").replace(/<\/svg>$/, "")}</g>
      <text x="60" y="104" text-anchor="middle" font-family="system-ui,sans-serif" font-size="12" font-weight="600" fill="${color}">${label}</text>
    </svg>`,
  );
}

/**
 * Rendered product-shot thumbnail (Blender batch → /assets/thumbs/<id>.webp).
 * Callers keep itemThumb() as the onerror fallback for assets without a render.
 */
export function renderedThumb(asset) {
  const id = asset?.asset_id ?? asset?.id;
  return id ? `/assets/thumbs/${encodeURIComponent(id)}.webp` : null;
}

/** Furniture item thumbnail — square icon for compact list rows. */
export function itemThumb(asset) {
  const color = CATEGORY_COLORS[asset.category] ?? "#94a3b8";
  const fp = asset.footprint ?? { w: 1, h: 0.8, d: 1 };
  const max = Math.max(fp.w, fp.d, 0.3);
  const bw = (fp.w / max) * 46;
  const bd = (fp.d / max) * 30;
  const bh = Math.min(26, Math.max(10, (fp.h / max) * 30));
  const x = 48 - bw / 2;
  const y = 42 - bh / 2;
  return svgUri(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96">
      <rect width="96" height="96" rx="10" fill="${color}22"/>
      <rect x="10" y="68" width="76" height="10" rx="3" fill="${color}" opacity="0.14"/>
      <rect x="${x.toFixed(1)}" y="${y.toFixed(1)}" width="${bw.toFixed(1)}" height="${bh.toFixed(1)}" rx="3" fill="${color}" opacity="0.92"/>
      <rect x="${x.toFixed(1)}" y="${(y + bh - 4).toFixed(1)}" width="${bw.toFixed(1)}" height="${bd.toFixed(1)}" rx="2" fill="${color}" opacity="0.55"/>
    </svg>`,
  );
}

export { CATEGORY_COLORS, CATEGORY_LABELS };
